import { render, staticRenderFns } from "./CorporationData_v3.vue?vue&type=template&id=08df46f4&"
import script from "./CorporationData_v3.vue?vue&type=script&lang=js&"
export * from "./CorporationData_v3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports